import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
let TextSetting = class TextSetting extends Vue {
  constructor() {
    super(...arguments);
    this.text = "";
  }
  dataChage(value) {
    this.text = value.text;
    console.log(this.text, "图片预览组件---", value);
  }
};
__decorate([Prop({
  type: Object,
  default: {}
})], TextSetting.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], TextSetting.prototype, "dataChage", null);
TextSetting = __decorate([Component({
  name: "textSetting"
})], TextSetting);
export default TextSetting;